import React, { Component } from 'react'
import './CreateGroup.css'
import { database, storage, ref, push, child, update, set, serverTimestamp, storageRef, uploadBytes, getDownloadURL, query, orderByChild, equalTo, get } from '../../firebase'
import AuthUserContext from '../../AuthUserContext.jsx'
import { BtnPrimary, BtnSecondary } from '../commons/Buttons'
import { withRouter } from '../../withRouter'
import Members from './Members.jsx'
import Info from './Info.jsx'
import Loading from '../commons/Loading'

class CreateGroup extends Component {
  constructor (props) {
    super(props)
    this.state = {
      members: [],
      title: '',
      mode: '',
      cover: null,
      step: 1,
      saving: false
    }
    this.onSubmit = this.onSubmit.bind(this)
  }
  onSubmit (admin) {
    this.setState({
      saving: true
    })
    const groupsRef = ref(database, 'grupos/index')
    const groupId = push(child(groupsRef, 'index')).key
    const members = this.state.members.concat(admin)
    const title = this.state.title
    const mode = this.state.mode
    this.uploadCover(groupId)
      .then((cover) => {
        const membersObject = {}
        members.forEach((member) => {
          membersObject[member.id] = true
        })
        const puntajeObject = {}
        members.forEach((member) => {
          puntajeObject[member.id] = 0
        })
        const updates = {}
        updates['index/' + groupId] = {
          cover: cover || 'https://firebasestorage.googleapis.com/v0/b/stadium-data.appspot.com/o/grupos%2Fcovers%2Fdefault.png?alt=media&token=20bf75cd-348a-466a-b0e7-e17c9cb8abba',
          titulo: title,
          admin: admin.id,
          created: serverTimestamp(),
          mode: mode
        }
        updates['miembros/' + groupId] = membersObject
        updates['puntaje/' + groupId + '/global'] = puntajeObject
        return update(ref(database, 'grupos'), updates)
      })
      .then(() => {
        const promises = []
        let count = 0
        members.forEach((member) => {
          promises[count] = new Promise((resolve, reject) => {
            set(ref(database, 'usuarios/grupos/' + member.id + '/' + groupId), true)
              .then(() => {
                resolve()
              })
              .catch((err) => {
                reject(err)
              })
          })
          count++
        })
        return Promise.all(promises)
      })
      .then(() => {
        this.setState({
          saving: false
        })
        this.props.history.push('/')
        this.props.closeModal()
      })
      .catch((err) => {
        console.error(err)
      })
  }
  uploadCover (groupId) {
    return new Promise((resolve, reject) => {
      if (this.state.cover) {
        this.state.cover.toBlob((blob) => {
          const coverRef = storageRef(storage, 'grupos/covers/' + groupId + '.jpg')
          uploadBytes(coverRef, blob)
            .then((snap) => {
              return getDownloadURL(storageRef(storage, snap.metadata.fullPath))
            })
            .then((url) => resolve(url))
            .catch((err) => reject(err))
        }, 'image/jpeg', 0.86)
      } else {
        resolve(null)
      }
    })
  }
  render () {
    return (
      <div className='create-group'>
        <div className='create-group__header'>
          <div className={this.state.step === 1 ? 'create-group__step create-group__step--current' : 'create-group__step'}><span>1</span>Agrega participantes</div>
          <div className={this.state.step === 2 ? 'create-group__step create-group__step--current' : 'create-group__step'}><span>2</span>Identifica el grupo</div>
        </div>
        {this.state.step === 1 && <Step1
          members={this.state.members}
          handleMembers={(members) => this.setState({ members: members })}
          goNext={() => this.setState({ step: 2 })}
        /> }
        {this.state.step === 2 && <Step2
          title={this.state.title}
          cover={this.state.cover}
          mode={this.state.mode}
          handleTitle={(value) => this.setState({ title: value })}
          handleCover={(value) => this.setState({ cover: value })}
          handleMode={(value) => this.setState({ mode: value })}
          goBack={() => this.setState({ step: 1 })}
          onSubmit={this.onSubmit}
          saving={this.state.saving}
        /> }
      </div>
    )
  }
}

class Step1 extends Component {
  render () {
    return (
      <div className='create-group__content'>
        <p>Busca por nombre a los jugadores con los que vas a competir y agrégalos dando click en ellos. Puedes omitir este paso e invitarlos una vez que el grupo está creado.</p>
        <AuthUserContext.Consumer>
          {(authUser) => (
            <Members admin={authUser.user} members={this.props.members} handleMembers={this.props.handleMembers} />
          )}
        </AuthUserContext.Consumer>
        <div className='create-group__row'>
          <BtnPrimary onClick={this.props.goNext}>Siguiente</BtnPrimary>
        </div>
      </div>
    )
  }
}

class Step2 extends Component {
  constructor (props) {
    super(props)
    this.state = {
      modes: []
    }
  }
  componentDidMount () {
    const modalidadesRef = ref(database, 'quinielas/modalidades')
    const q = query(modalidadesRef, orderByChild('active'), equalTo(true))
    get(q)
      .then((snap) => {
        const modes = []
        snap.forEach((child) => {
          modes.push({
            value: child.key,
            label: child.val().titulo
          })
        })
        this.setState({
          modes: modes
        })
      })
      .catch((err) => {
        console.error(err)
      })
  }
  render () {
    return (
      <div className='create-group__content'>
        <p>Por último, dale un nombre al grupo y selecciona la modalidad de quiniela con la que van a participar. Si lo deseas, agrega una imagen como ícono. ¡A jugar!</p>
        <Info title={this.props.title} handleTitle={this.props.handleTitle} handleCover={this.props.handleCover} handleMode={this.props.handleMode} cover={this.props.cover} modes={this.state.modes} mode={this.props.mode} />
        <div className='create-group__row'>
          <div className='create-group__col'>
            <BtnSecondary onClick={this.props.goBack}>Regresar</BtnSecondary>
          </div>
          <div className='create-group__col'>
            <AuthUserContext.Consumer>
              {(authUser) => (
                <BtnPrimary onClick={() => this.props.onSubmit(authUser.user)} disabled={!this.props.title || !this.props.mode || this.props.saving}>{this.props.saving ? <Loading /> : 'Finalizar'}</BtnPrimary>
              )}
            </AuthUserContext.Consumer>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(CreateGroup)
